import React, { useEffect, useState, useMemo, useRef } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import uuid from "react-uuid";
import {
  DateHelper, FormHelper,
  StyleHelper,
  TIPO_NOTAS_CANCELACION,
  ESTADO_ECF_ACEPTADO, ESTADO_ECF_ACEPTADO_LABEL,
  ESTADO_ECF_ACEPTADO_CONDICIONAL_LABEL, ESTADO_ECF_ACEPTADO_CONDICIONAL
} from "utils";
import { Permisos } from "utils/permisos";
import { CurrencyInput } from "components/PantallasEdit/CurrencyInput/CurrencyInput";
import RadioGroup from "components/RadioGroup/RadioGroup";
import { GridView, ItemLookup, TerceroLookup, TransaccionesLookup, SvgComponent, RncLookup } from "components";
import EditHeader from "components/PantallasEdit/Header/EditHeader";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import EditContainer from "components/PantallasEdit/EditContainer/EditContainer";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import { DateTimePicker } from "components/DateTimePicker/DateTimePicker";
import IconButton from "components/IconButton/IconButton";
import ToolTip from "components/ToolTip/ToolTip";
import ReporteViewer from "components/Reportes/ReporteViewer";
import { AnimatedIconButton } from "components/AnimatedIconButton/AnimatedIconButton";
import ModalContainer from "components/ModalContainer/ModalContainer";
import { useAuthentication } from "hooks"
import useMessage from "hooks/useMessage";
import useExceptionHandler from "hooks/useExceptionHandler";
import useQueryParams from "hooks/useQueryParams";
import { TransaccionesManager } from "managers";
import { CondicionPagoManager } from "managers";
import {
  eCF,
  TIPO_COMPROBANTE_FACTURA_CREDITO_FISCAL,
  TIPO_COMPROBANTE_FACTURA_CONSUMO,
  MONTO_LIMITE_FACTURA_CONSUMO,
  TIPO_COMPROBANTE_NOTA_DEBITO,
  TIPO_COMPROBANTE_NOTA_CREDITO,
  TIPO_COMPROBANTE_COMPRAS,
  TIPO_COMPROBANTE_GASTO_MENOR,
  TIPO_COMPROBANTE_REGIMEN_ESPECIAL,
  TIPO_COMPROBANTE_GUBERNAMENTAL,
  TIPO_COMPROBANTE_EXPORTACIONES,
  TIPO_COMPROBANTE_PAGOS_EXTERIOR,
  TIPO_PAGO_CREDITO,
  TIPO_PAGO_CONTADO,
  MONEDA_PESO_DOMINICANO_ISO,
  TIPO_DESCUENTO_RECARGO_MONTO,
  TIPO_DESCUENTO_RECARGO_PORCENTAJE,
  TIPO_INGRESOS_OPERACIONES,
  INDICADOR_FACTURACION_NO_FACTURABLE, INDICADOR_FACTURACION_NO_FACTURABLE_LABEL,
  INDICADOR_FACTURACION_ITBIS_TASA_1, INDICADOR_FACTURACION_ITBIS_TASA_1_LABEL,
  INDICADOR_FACTURACION_ITBIS_TASA_2, INDICADOR_FACTURACION_ITBIS_TASA_2_LABEL,
  INDICADOR_FACTURACION_ITBIS_TASA_3, INDICADOR_FACTURACION_ITBIS_TASA_3_LABEL,
  INDICADOR_FACTURACION_ITBIS_EXENTO, INDICADOR_FACTURACION_ITBIS_EXENTO_LABEL,
  INDICADOR_FACTURACION_ITBIS_18_10_PORCIENTO, INDICADOR_FACTURACION_ITBIS_18_10_PORCIENTO_LABEL
} from "models/ECF/ECF";
import {
  Tercero,
  TIPO_DOCUMENTO_CEDULA,
  TIPO_DOCUMENTO_RNC,
  TIPO_DOCUMENTO_PASAPORTE,
} from "models/ECF/Tercero";
import {
  RETENCIONES_ITBIS_CXC_OPTIONS, RETENCIONES_ITBIS_CXP_OPTIONS,
  RETENCIONES_ISR_CXC_OPTIONS, RETENCIONES_ISR_CXP_OPTIONS,
} from "models/ECF/Retenciones";
import CondicionPagoEditCanvas from "views/CondicionPago/CondicionPagoEditCanvas";

function MontoField({ value }) {
  return (
    <Form.Control
      type="text"
      readOnly
      value={value}
      style={{ maxWidth: '150px', backgroundColor: '#f8f9fa', fontWeight: 'bold', textAlign: 'right' }}
      tabIndex={-1}
    />
  );
}

export default function TransaccionesEdit({ showLoading, hideLoading }) {
  const history = useHistory();
  const URLParameters = useQueryParams();
  const Id = URLParameters.get("Id");
  const autoprint = URLParameters.get("autoprint") === "true";
  const isReadonly = !!Id;
  const [transaccion, setTransaccion] = useState({});
  const { usuario, tienePermiso } = useAuthentication();
  const [detalles, setDetalles] = useState([]);
  const [itemSeleccionado, setItemSeleccionado] = useState({});
  const [descuentoGlobalSeleccionado, setDescuentoGlobalSeleccionado] = useState({});
  const [showSubDescuentoModal, setShowSubDescuentoModal] = useState(false);
  const [indiceDetalleParaDescuento, setIndiceDetalleParaDescuento] = useState(null);
  const [subDescuentoSeleccionado, setSubDescuentoSeleccionado] = useState({});
  const [terceroSeleccionado, setTerceroSeleccionado] = useState({});
  const terceroLookupRef = useRef(null);
  const itemLookupRef = useRef(null);
  const [ncfModificadoSeleccionado, setNcfModificadoSeleccionado] = useState({});
  const [tituloHeader, setTituloHeader] = useState("Emitir E-CF");
  const { Message, Warning, cerrarAlertas } = useMessage();
  const { handleException } = useExceptionHandler();
  const [reporte, setReporte] = useState(null);
  const [showCanvasReporte, setShowCanvasReporte] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showCancelarModal, setShowCancelarModal] = useState(false);
  const [cancelacionData, setCancelacionData] = useState({});
  const [pagination, setPagination] = useState({
    EsPaginable: false,
  });

  const [condicionesDePago, setCondicionesDePago] = useState([]);
  const [condicionPagoSeleccionada, setCondicionPagoSeleccionada] = useState(null);
  const [fechaVencimientoSecuenciaFilterkey, setFechaVencimientoSecuenciaFilterkey] = useState(uuid());
  const [fechaEmisionFilterkey, setFechaEmisionFilterkey] = useState(uuid());
  const [fechaLimitePagoFilterkey, setFechaLimitePagoFilterkey] = useState(uuid());
  const [fechaNcfModificadoFilterkey, setFechaNcfModificadoFilterkey] = useState(uuid());
  const [itemLookupKey, setItemLookupKey] = useState(uuid());
  const [rncLookupKey, setRncLookupKey] = useState(uuid());
  const [terceroLookupKey, setTerceroLookupKey] = useState(uuid());
  const [showCondicionPagoEditCanvas, setShowCondicionPagoEditCanvas] = useState(false);
  const [showInfoReferencia, setShowInfoReferencia] = useState(false);
  const [showCambiarTipoECFConfirmModal, setShowCambiarTipoECFConfirmModal] = useState(false);
  const [pendingTipoeCF, setPendingTipoeCF] = useState(null);

  const puedeEditarPrecio = tienePermiso(Permisos.Transacciones.EDITAR_PRECIO);
  const puedeEditarITBIS = tienePermiso(Permisos.Transacciones.EDITAR_ITBIS);
  const puedeEditarRetITBIS = tienePermiso(Permisos.Transacciones.EDITAR_RET_ITBIS);
  const puedeEditarRetISR = tienePermiso(Permisos.Transacciones.EDITAR_RET_ISR);
  const puedeEditarAlgunCampoFila =
    puedeEditarPrecio || puedeEditarITBIS || puedeEditarRetITBIS || puedeEditarRetISR;

  const [filasEnEdicion, setFilasEnEdicion] = useState(() => new Set());

  const toggleFilaEnEdicion = (index) => {
    setFilasEnEdicion((prev) => {
      const next = new Set(prev);
      if (next.has(index)) next.delete(index);
      else next.add(index);
      return next;
    });
  };

  const filaEditable = (index, permiso) =>
    !isReadonly && permiso && filasEnEdicion.has(index);

  const esVenta = eCF.TIPO_COMPROBANTE_VENTA_LIST?.some(o => o.value === transaccion.TipoeCF) ?? false;
  const esCompra = eCF.TIPO_COMPROBANTE_COMPRA_LIST?.some(o => o.value === transaccion.TipoeCF) ?? false;

  const tipoTerceroLabel = esVenta
    ? "Cliente"
    : esCompra
      ? "Proveedor"
      : "Cliente | Proveedor";

  const sectionTitleTercero = `Información de ${tipoTerceroLabel}`;
  const documentoTerceroLabel = `Documento ${tipoTerceroLabel}`;
  const razonSocialTerceroLabel = `Razón Social ${tipoTerceroLabel}`;

  const terceroWhereFijo = esVenta
    ? { EsCliente: true }
    : esCompra
      ? { EsProveedor: true }
      : {};

  const itemWhereFijo = esVenta
    ? { EsVendible: true }
    : esCompra
      ? { EsComprable: true }
      : {};

  const [formasPagos, setFormasPagos] = useState([]);
  const [formaPagoSeleccionada, setFormaPagoSeleccionada] = useState(null);
  const [montoCobradoSeleccionado, setMontoCobradoSeleccionado] = useState(0);
  const [filasFormasPagosEnEdicion, setFilasFormasPagosEnEdicion] = useState(() => new Set());

  const toggleFilaFormaPagoEnEdicion = (index) => {
    setFilasFormasPagosEnEdicion((prev) => {
      const next = new Set(prev);
      if (next.has(index)) next.delete(index);
      else next.add(index);
      return next;
    });
  };

  const mostrarDetallesCobro = esVenta
    && transaccion.TipoPago === TIPO_PAGO_CONTADO
    && transaccion.TipoeCF !== TIPO_COMPROBANTE_GASTO_MENOR
    && (!isReadonly || formasPagos.length > 0);

  const cargarCondicionesDePago = () => {
    CondicionPagoManager
      .listado({ EsPaginable: false, NoEstatus: "I" })
      .then((res) => setCondicionesDePago(res.Data ?? []))
      .catch(() => { });
  };

  useEffect(() => {
    cerrarAlertas();
    setFilasEnEdicion(new Set());

    if (Id) {
      setTituloHeader("Ver E-CF");
      showLoading();
      TransaccionesManager
        .verPorId(Id)
        .then((res) => {
          const data = res.Data ?? res;

          const descuentos = data.DescuentosRecargos ?? [];
          const TipoDescuentoGlobal = descuentos.length > 0 ? TIPO_DESCUENTO_RECARGO_MONTO : null;
          const DescuentoGlobal = descuentos.length > 0
            ? descuentos.reduce((sum, d) => sum + (d.MontoDescuentooRecargo ?? 0), 0)
            : null;
          setTransaccion({
            ...data,
            TipoIngresos: data.TipoIngresos != null
              ? String(data.TipoIngresos).padStart(2, "0")
              : data.TipoIngresos,
            DocumentoComprador: data.RNCComprador ?? data.IdentificadorExtranjero,
            EstadoECF: data.EstadoECF ?? data.EstadoeCF,
            eCFCancelado: data.eCFCancelado,
            eNCF: data.eNCF,
            CorreoComprador: data.CorreoComprador,
            TipoDescuentoGlobal,
            DescuentoGlobal,
          });

          setDetalles((data.DetallesItem ?? []).map((item) => ({
            ...item,
            Nombre: item.NombreItem,
            Cantidad: item.CantidadItem,
            PrecioUnitario: item.PrecioUnitarioItem,
            IndicadorBienOServicio: item.IndicadorBienoServicio,
          })));
          setFormasPagos((data.FormaPagos ?? []).map(fp => ({
            FormaPago: fp.FormaPago,
            MontoPago: fp.MontoPago,
          })));
          setShowInfoReferencia(true);
          if (autoprint) {
            return representacionImpresa(Id);
          }
        })
        .catch(handleException)
        .finally(hideLoading);
    } else {
      setTituloHeader("Emitir E-CF");
      setTransaccion({});
      setDetalles([]);
      setFormasPagos([]);
      setFormaPagoSeleccionada(null);
      setMontoCobradoSeleccionado(0);
      setFilasFormasPagosEnEdicion(new Set());
      setTerceroSeleccionado({});
      setNcfModificadoSeleccionado({});
      setCondicionPagoSeleccionada(null);
      setShowInfoReferencia(false);
      setRncLookupKey(uuid());
      setTerceroLookupKey(uuid());
      cargarCondicionesDePago();
      setDefaultValues();
      hideLoading();
    }
  }, [Id]);

  const setDefaultValues = () => {
    setTransaccion({
      TipoeCF: TIPO_COMPROBANTE_FACTURA_CONSUMO,
      TipoMoneda: MONEDA_PESO_DOMINICANO_ISO,
      FechaEmision: DateHelper.formatDate(new Date()),
      TipoIngresos: TIPO_INGRESOS_OPERACIONES,
      TipoPago: TIPO_PAGO_CONTADO
    });
  };

  function grabar() {
    showLoading();

    const { TipoDescuentoGlobal, DescuentoGlobal, ...transaccionBase } = transaccion;

    const request = {
      ...transaccionBase,
      DescuentosRecargos: TipoDescuentoGlobal && DescuentoGlobal
        ? [{
          NumeroLinea: 1,
          TipoAjuste: "D",
          TipoValor: TipoDescuentoGlobal,
          DescripcionDescuentooRecargo: "Descuento",
          ValorDescuentooRecargo: TipoDescuentoGlobal === TIPO_DESCUENTO_RECARGO_PORCENTAJE ? DescuentoGlobal : null,
          MontoDescuentooRecargo: TipoDescuentoGlobal === TIPO_DESCUENTO_RECARGO_MONTO ? DescuentoGlobal : null,
        }]
        : [],
      DetallesItem: detalles.map((d, index) => ({
        NumeroLinea: index + 1,
        ItemId: d.value,
        NombreItem: d.Nombre,
        IndicadorFacturacion: d.IndicadorFacturacion,
        IndicadorBienoServicio: d.IndicadorBienOServicio,
        PrecioUnitarioItem: d.PrecioUnitario,
        PrecioUnitarioReferencia: d.PrecioUnitarioReferencia,
        CantidadItem: d.Cantidad ?? d.CantidadItem,
        MontoITBISRetenido: d.TotalRetencionItbis ?? d.MontoITBISRetenido ?? 0,
        MontoISRRetenido: d.TotalRetencionIsr ?? d.MontoISRRetenido ?? 0,
        TipoRetencionITBIS: d.TipoRetencionITBIS ?? null,
        TipoRetencionISR: d.TipoRetencionISR ?? null,
        SubDescuentos: d.SubDescuentos || [],
      })),
      FormaPagos: mostrarDetallesCobro
        ? formasPagos.map(fp => ({
          FormaPago: fp.FormaPago,
          MontoPago: fp.MontoPago,
          MontoRecibido: null,
        }))
        : [],
    };

    TransaccionesManager.crearECF(request)
      .then((_res) => {
        Message({ message: `Grabado Exitosamente` });
        const newId = _res.Data?.TransaccionId ?? _res?.TransaccionId;
        history.push(`/TransaccionesEdit?Id=${newId}&autoprint=true`);
      })
      .catch((e) => handleException(e))
      .finally(() => hideLoading());
  }

  const representacionImpresa = (IdSec) => {
    showLoading();
    return TransaccionesManager
      .representacionImpresa(IdSec)
      .then((res) => {
        setReporte(res.Data);
        setShowCanvasReporte(true);
      })
      .catch((err) => {
        handleException(err);
      })
      .finally(() => hideLoading());
  };

  const descargarArchivoXML = () => {
    showLoading();
    TransaccionesManager
      .descargarArchivoXML(Id)
      .then((res) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(res);
        link.download = `${transaccion.eNCF}.xml`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err) => handleException(err))
      .finally(() => hideLoading());
  };

  const descargarArchivoRespuestaXML = () => {
    showLoading();
    TransaccionesManager
      .descargarArchivoRespuestaXML(Id)
      .then((res) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(res);
        link.download = `${transaccion.eNCF}_respuesta.xml`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err) => handleException(err))
      .finally(() => hideLoading());
  };

  const abrirLinkQR = () => {
    showLoading();
    TransaccionesManager
      .visualizarLinkQR(Id)
      .then((res) => window.open(res.Data.url, "_blank"))
      .catch((err) => handleException(err))
      .finally(() => hideLoading());
  };

  const handleEmailClick = () => setShowEmailModal(true);

  const enviarRepresentacionEmail = () => {
    showLoading();
    TransaccionesManager
      .enviarEmail(Id, transaccion.CorreoComprador)
      .then(() => {
        setShowEmailModal(false);
        Message({ message: "Email enviado Exitosamente." });
      })
      .catch((err) => handleException(err))
      .finally(() => hideLoading());
  };

  const handleCancelarClick = () => {
    if (transaccion.eCFCancelado) {
      Warning({ message: "Ya fue generada una Nota de Cancelación para este comprobante." });
      return;
    }
    setCancelacionData({
      ...transaccion,
      TipoNotaCancelacion: transaccion.eNCF?.startsWith("E34")
        ? TIPO_COMPROBANTE_NOTA_DEBITO
        : TIPO_COMPROBANTE_NOTA_CREDITO,
      fechaEmisionCancelacion: new Date(),
      fechaVencimientoSecuenciaCancelacion: new Date(new Date().getFullYear(), 11, 31, 23, 59, 59, 999),
    });
    if (
      transaccion.EstadoECF == ESTADO_ECF_ACEPTADO ||
      transaccion.EstadoECF == ESTADO_ECF_ACEPTADO_CONDICIONAL
    ) {
      setShowCancelarModal(true);
    } else {
      Warning({ message: `Para generar Nota de Cancelación el comprobante debe ser ${ESTADO_ECF_ACEPTADO_LABEL}.` });
    }
  };

  const cancelarECF = () => {
    showLoading();
    TransaccionesManager
      .cancelarECF({
        TransaccionId: Id,
        fechaEmisionCancelacion: cancelacionData.fechaEmisionCancelacion,
        TipoNota: cancelacionData.TipoNotaCancelacion,
        NCFCancelacion: cancelacionData.NCFCancelacion,
        FechaVencimientoSecuenciaCancelacion: cancelacionData.fechaVencimientoSecuenciaCancelacion,
      })
      .then((res) => {
        if (
          res.Data.EstadoeCF != ESTADO_ECF_ACEPTADO_LABEL &&
          res.Data.EstadoeCF != ESTADO_ECF_ACEPTADO_CONDICIONAL
        ) {
          Warning({ message: res.Data.Mensaje });
          return;
        }
        Message({ message: "Nota de Cancelación generada Exitosamente." });
        setShowCancelarModal(false);
      })
      .catch((err) => handleException(err))
      .finally(() => hideLoading());
  };

  const handleVolverClick = () => {
    const urlBase = `/TransaccionesList`;
    history.push(urlBase);
  };

  const handleCleanClick = () => {
    history.push('/TransaccionesEdit');
  };

  const handleEliminarDetalle = (indiceAEliminar) => {
    const nuevosDetalles = detalles.filter((_, indice) => indice !== indiceAEliminar);
    setDetalles(nuevosDetalles);
    setFilasEnEdicion(new Set());
  };

  const handleAgregarFormaPagoClick = () => {
    if (!formaPagoSeleccionada) {
      Warning({ message: "Seleccione una Forma de Pago." });
      return;
    }
    if (!montoCobradoSeleccionado || montoCobradoSeleccionado <= 0) {
      Warning({ message: "Ingrese un Monto Cobrado válido." });
      return;
    }
    setFormasPagos([
      ...formasPagos,
      { FormaPago: formaPagoSeleccionada, MontoPago: montoCobradoSeleccionado },
    ]);
    setFormaPagoSeleccionada(null);
    setMontoCobradoSeleccionado(0);
  };

  const handleEliminarFormaPago = (index) => {
    setFormasPagos(formasPagos.filter((_, i) => i !== index));
    setFilasFormasPagosEnEdicion(new Set());
  };

  const handleFormaPagoChange = (index, campo, valor) => {
    const next = [...formasPagos];
    next[index] = { ...next[index], [campo]: valor };
    setFormasPagos(next);
  };

  const CAMPOS_QUE_AFECTAN_RETENCION = new Set([
    "Cantidad", "PrecioUnitario", "IndicadorFacturacion",
    "TipoRetencionITBIS", "TipoRetencionISR",
  ]);

  const handleDetalleChange = (index, event) => {
    const nuevosDetalles = [...detalles];
    const { name, value } = event.target;

    nuevosDetalles[index] = { ...nuevosDetalles[index], [name]: value };

    if (CAMPOS_QUE_AFECTAN_RETENCION.has(name)) {
      nuevosDetalles[index] = recalcularRetencionesLinea(nuevosDetalles[index], nuevosDetalles, transaccion);
    }

    setDetalles(nuevosDetalles);
  };

  const CXP_TIPOS = [TIPO_COMPROBANTE_COMPRAS, TIPO_COMPROBANTE_PAGOS_EXTERIOR];
  const itbisOptionsForTipo = CXP_TIPOS.includes(transaccion.TipoeCF)
    ? RETENCIONES_ITBIS_CXP_OPTIONS
    : RETENCIONES_ITBIS_CXC_OPTIONS;
  const isrOptionsForTipo = CXP_TIPOS.includes(transaccion.TipoeCF)
    ? RETENCIONES_ISR_CXP_OPTIONS
    : RETENCIONES_ISR_CXC_OPTIONS;

  const getTipoDocumentoPorLongitud = (documento) => {
    const len = (documento || "").length;
    if (len === 0) return "";
    if (len === 9) return TIPO_DOCUMENTO_RNC;
    if (len === 11) return TIPO_DOCUMENTO_CEDULA;
    return TIPO_DOCUMENTO_PASAPORTE;
  };

  const MENSAJE_ITBIS_MIXTO = "Para aplicar descuento global los items deben tener el mismo tipo de ITBIS. Si desea aplicar descuento, debe hacerlo de forma detallada.";
  const MENSAJE_RETENCION_INCOMPATIBLE = "No es posible agregar un descuento general a facturas con retención. Si desea agregar descuento, debe colocarlo de manera detallada.";

  const algunItemTieneRetencion = (lista) =>
    (lista || []).some(d => d.TipoRetencionITBIS || d.TipoRetencionISR);

  const todosMismoIndicador = (lista) => {
    const filtrados = (lista || []).filter(d => d.IndicadorFacturacion !== INDICADOR_FACTURACION_NO_FACTURABLE);
    if (filtrados.length === 0) return true;
    const primero = filtrados[0].IndicadorFacturacion;
    return filtrados.every(d => d.IndicadorFacturacion === primero);
  };

  const calcularLineaConDescuento = (linea, listaDetalles, transaccionRef, itbisOpts, isrOpts) => {
    const cantidad = parseFloat(linea.Cantidad ?? linea.CantidadItem ?? 1) || 0;
    const precio = parseFloat(linea.PrecioUnitario ?? 0) || 0;
    const bruto = precio * cantidad;

    const sub = linea.SubDescuentos?.[0];
    let descLinea = 0;
    if (sub) {
      if (sub.TipoSubDescuento === TIPO_DESCUENTO_RECARGO_MONTO)
        descLinea = sub.MontoSubDescuento || 0;
      else if (sub.TipoSubDescuento === TIPO_DESCUENTO_RECARGO_PORCENTAJE)
        descLinea = ((sub.SubDescuentoPorcentaje || 0) / 100) * bruto;
    }

    let descGlobal = 0;
    const tipoGlobal = transaccionRef?.TipoDescuentoGlobal;
    const valorGlobal = transaccionRef?.DescuentoGlobal || 0;
    if (tipoGlobal === TIPO_DESCUENTO_RECARGO_PORCENTAJE) {
      descGlobal = (valorGlobal / 100) * bruto;
    } else if (tipoGlobal === TIPO_DESCUENTO_RECARGO_MONTO && valorGlobal > 0) {
      const brutoTotalFacturable = (listaDetalles || [])
        .filter(d => d.IndicadorFacturacion !== INDICADOR_FACTURACION_NO_FACTURABLE)
        .reduce((acc, d) => acc + ((parseFloat(d.PrecioUnitario ?? 0) || 0) * (parseFloat(d.Cantidad ?? d.CantidadItem ?? 1) || 0)), 0);
      if (brutoTotalFacturable > 0 && linea.IndicadorFacturacion !== INDICADOR_FACTURACION_NO_FACTURABLE) {
        descGlobal = (bruto / brutoTotalFacturable) * valorGlobal;
      }
    }

    const baseDescontada = Math.max(0, bruto - descLinea - descGlobal);
    // Retentions ignore the global discount — only line-level sub-descuento reduces the base.
    const baseRetencion = Math.max(0, bruto - descLinea);

    const tasaITBIS = eCF.INDICADORES_FACTURACION_TASAS[linea.IndicadorFacturacion] ?? 0;
    const itbisLinea = baseDescontada * tasaITBIS;
    const itbisLineaSinGlobal = baseRetencion * tasaITBIS;

    const itbisOpt = itbisOpts?.find(o => o.value === linea.TipoRetencionITBIS);
    const isrOpt = isrOpts?.find(o => o.value === linea.TipoRetencionISR);

    return {
      baseDescontada,
      descLinea,
      descGlobal,
      itbisLinea,
      MontoITBISRetenido: itbisOpt ? itbisLineaSinGlobal * (itbisOpt.valor / 100) : 0,
      MontoISRRetenido: isrOpt ? baseRetencion * (isrOpt.valor / 100) : 0,
    };
  };

  const recalcularRetencionesLinea = (linea, listaDetalles, transaccionRef) => {
    const { MontoITBISRetenido, MontoISRRetenido } = calcularLineaConDescuento(
      linea, listaDetalles, transaccionRef, itbisOptionsForTipo, isrOptionsForTipo
    );
    return { ...linea, MontoITBISRetenido, MontoISRRetenido };
  };

  const recalcularTodasLasRetenciones = (lista, transaccionRef) =>
    lista.map(l => recalcularRetencionesLinea(l, lista, transaccionRef));

  const recalcularRetencionesItemSeleccionado = (item) =>
    recalcularRetencionesLinea(item, [...detalles, item], transaccion);


  const subtotal = useMemo(() => {
    return detalles
      .filter(item => item.IndicadorFacturacion !== 0)
      .reduce(
        (acc, item) => acc + ((item.PrecioUnitario || 0) * (item.Cantidad || 0)),
        0
      );
  }, [detalles]);

  const totalITBISRetenido = useMemo(() => {
    if (isReadonly) {
      return detalles.reduce((acc, item) => acc + (Number(item.MontoITBISRetenido) || 0), 0);
    }
    return detalles
      .filter(item => item.IndicadorFacturacion !== 0 && item.IndicadorFacturacion !== 3 && item.IndicadorFacturacion !== 4)
      .reduce((acc, item) => {
        const { MontoITBISRetenido } = calcularLineaConDescuento(
          item, detalles, transaccion, itbisOptionsForTipo, isrOptionsForTipo
        );
        return acc + (MontoITBISRetenido || 0);
      }, 0);
  }, [detalles, transaccion.TipoDescuentoGlobal, transaccion.DescuentoGlobal, isReadonly]);

  const totalISRRetenido = useMemo(() => {
    if (isReadonly) {
      return detalles.reduce((acc, item) => acc + (Number(item.MontoISRRetenido) || 0), 0);
    }
    return detalles
      .filter(item => item.IndicadorFacturacion !== 0)
      .reduce((acc, item) => {
        const { MontoISRRetenido } = calcularLineaConDescuento(
          item, detalles, transaccion, itbisOptionsForTipo, isrOptionsForTipo
        );
        return acc + (MontoISRRetenido || 0);
      }, 0);
  }, [detalles, transaccion.TipoDescuentoGlobal, transaccion.DescuentoGlobal, isReadonly]);

  const montosDesglosados = useMemo(() => {
    const fmt = (n) => n.toLocaleString('es-DO', { minimumFractionDigits: 2 });
    const sum = (ind) => detalles
      .filter(i => i.IndicadorFacturacion === ind)
      .reduce((acc, i) => acc + (i.PrecioUnitario || 0) * (i.Cantidad || 0), 0);

    const descuentoSum = (ind) => detalles
      .filter(i => i.IndicadorFacturacion === ind)
      .reduce((acc, i) => {
        const sub = i.SubDescuentos?.[0];
        if (!sub) return acc;
        if (sub.TipoSubDescuento === TIPO_DESCUENTO_RECARGO_MONTO)
          return acc + (sub.MontoSubDescuento || 0);
        if (sub.TipoSubDescuento === TIPO_DESCUENTO_RECARGO_PORCENTAJE)
          return acc + (sub.SubDescuentoPorcentaje / 100) * (i.PrecioUnitario || 0) * (i.Cantidad || 0);
        return acc;
      }, 0);

    const base0 = sum(INDICADOR_FACTURACION_NO_FACTURABLE);
    const base1 = sum(INDICADOR_FACTURACION_ITBIS_TASA_1);
    const base2 = sum(INDICADOR_FACTURACION_ITBIS_TASA_2);
    const base3 = sum(INDICADOR_FACTURACION_ITBIS_TASA_3);
    const base4 = sum(INDICADOR_FACTURACION_ITBIS_EXENTO);
    const base5 = sum(INDICADOR_FACTURACION_ITBIS_18_10_PORCIENTO);

    const descuento0 = descuentoSum(INDICADOR_FACTURACION_NO_FACTURABLE);
    const descuento1 = descuentoSum(INDICADOR_FACTURACION_ITBIS_TASA_1);
    const descuento2 = descuentoSum(INDICADOR_FACTURACION_ITBIS_TASA_2);
    const descuento3 = descuentoSum(INDICADOR_FACTURACION_ITBIS_TASA_3);
    const descuento4 = descuentoSum(INDICADOR_FACTURACION_ITBIS_EXENTO);
    const descuento5 = descuentoSum(INDICADOR_FACTURACION_ITBIS_18_10_PORCIENTO);

    const descuentoLineaTotal = descuento1 + descuento2 + descuento3 + descuento4 + descuento5;

    const descuentoGlobalMonto = transaccion.TipoDescuentoGlobal === TIPO_DESCUENTO_RECARGO_PORCENTAJE
      ? ((transaccion.DescuentoGlobal || 0) / 100) * subtotal
      : (transaccion.DescuentoGlobal || 0);

    const descuentoTotalGeneral = descuentoLineaTotal + descuentoGlobalMonto;

    const indicadorGlobal = transaccion.TipoDescuentoGlobal
      ? detalles.find(d => d.IndicadorFacturacion !== INDICADOR_FACTURACION_NO_FACTURABLE)?.IndicadorFacturacion
      : null;
    const globalEn = (ind) => indicadorGlobal === ind ? descuentoGlobalMonto : 0;

    const impuesto1 = (base1 - descuento1 - globalEn(INDICADOR_FACTURACION_ITBIS_TASA_1)) * 0.18;
    const impuesto2 = (base2 - descuento2 - globalEn(INDICADOR_FACTURACION_ITBIS_TASA_2)) * 0.16;
    const impuesto3 = (base3 - descuento3 - globalEn(INDICADOR_FACTURACION_ITBIS_TASA_3)) * 0;
    const impuesto5 = (base5 - descuento5 - globalEn(INDICADOR_FACTURACION_ITBIS_18_10_PORCIENTO)) * 0.10 * 0.18;

    const subtotal1 = (base1 - descuento1 - globalEn(INDICADOR_FACTURACION_ITBIS_TASA_1)) + impuesto1;
    const subtotal2 = (base2 - descuento2 - globalEn(INDICADOR_FACTURACION_ITBIS_TASA_2)) + impuesto2;
    const subtotal3 = (base3 - descuento3 - globalEn(INDICADOR_FACTURACION_ITBIS_TASA_3)) + impuesto3;
    const subtotal4 = (base4 - descuento4 - globalEn(INDICADOR_FACTURACION_ITBIS_EXENTO));
    const subtotal5 = (base5 - descuento5 - globalEn(INDICADOR_FACTURACION_ITBIS_18_10_PORCIENTO)) + impuesto5;

    const impuestoTotal = impuesto1 + impuesto2 + impuesto5;
    const montoTotalConImpuestos = subtotal1 + subtotal2 + subtotal3 + subtotal4 + subtotal5;

    return {
      base0Fmt: fmt(base0),
      base1Fmt: fmt(base1), impuesto1Fmt: fmt(impuesto1), subtotal1Fmt: fmt(subtotal1),
      base2Fmt: fmt(base2), impuesto2Fmt: fmt(impuesto2), subtotal2Fmt: fmt(subtotal2),
      base3Fmt: fmt(base3), impuesto3Fmt: fmt(impuesto3), subtotal3Fmt: fmt(subtotal3),
      base4Fmt: fmt(base4), subtotal4Fmt: fmt(subtotal4),
      base5Fmt: fmt(base5), impuesto5Fmt: fmt(impuesto5), subtotal5Fmt: fmt(subtotal5),
      impuestoTotal,
      impuestoTotalFmt: fmt(impuestoTotal),
      montoTotalConImpuestos,
      montoTotalConImpuestosFmt: fmt(montoTotalConImpuestos),
      descuento0Fmt: fmt(descuento0),
      descuento1Fmt: fmt(descuento1),
      descuento2Fmt: fmt(descuento2),
      descuento3Fmt: fmt(descuento3),
      descuento4Fmt: fmt(descuento4),
      descuento5Fmt: fmt(descuento5),
      descuentoLineaTotalFmt: fmt(descuentoLineaTotal),
      descuentoGlobalFmt: fmt(descuentoGlobalMonto),
      descuentoTotalFmt: fmt(descuentoTotalGeneral),
    };
  }, [detalles, transaccion.TipoDescuentoGlobal, transaccion.DescuentoGlobal, subtotal]);

  const esFacturaConsumo = transaccion.TipoeCF === TIPO_COMPROBANTE_FACTURA_CONSUMO;
  const facturaConsumoSobreLimite =
    esFacturaConsumo &&
    (montosDesglosados.montoTotalConImpuestos ?? 0) >= MONTO_LIMITE_FACTURA_CONSUMO;
  const ocultarTerceroSection = esFacturaConsumo && !facturaConsumoSobreLimite;

  const tieneInformacionReferencia = !!(
    transaccion.NCFModificado ||
    transaccion.FechaNCFModificado ||
    transaccion.CodigoModificacion
  );

  useEffect(() => {
    if (ocultarTerceroSection && !isReadonly) {
      setTerceroSeleccionado({});
      setTransaccion((prev) => ({
        ...prev,
        TipoDocumentoComprador: "",
        DocumentoComprador: "",
        RazonSocialComprador: "",
      }));
      setTerceroLookupKey(uuid());
      setRncLookupKey(uuid());
    }
  }, [ocultarTerceroSection, isReadonly]);

  const totalCobrado = useMemo(
    () => (formasPagos ?? []).reduce((sum, fp) => sum + (Number(fp.MontoPago) || 0), 0),
    [formasPagos]
  );

  const totalAPagar = useMemo(
    () => (montosDesglosados.montoTotalConImpuestos ?? 0) - totalITBISRetenido - totalISRRetenido,
    [montosDesglosados.montoTotalConImpuestos, totalITBISRetenido, totalISRRetenido]
  );

  const faltaPorCobrar = useMemo(
    () => Math.max(totalAPagar - totalCobrado, 0),
    [totalAPagar, totalCobrado]
  );

  const totalDevuelta = useMemo(
    () => Math.max(totalCobrado - totalAPagar, 0),
    [totalAPagar, totalCobrado]
  );

  const itbisCalculado = (itemSeleccionado?.PrecioUnitario || 0)
    * (itemSeleccionado?.Cantidad || 1)
    * (eCF.INDICADORES_FACTURACION_TASAS[itemSeleccionado?.IndicadorFacturacion] ?? 0);

  const esNotaDebito = transaccion.TipoeCF === TIPO_COMPROBANTE_NOTA_DEBITO;
  const esNotaCredito = transaccion.TipoeCF === TIPO_COMPROBANTE_NOTA_CREDITO;

  const handleAbrirSubDescuentoModal = (index) => {
    setIndiceDetalleParaDescuento(index);
    setSubDescuentoSeleccionado({});
    setShowSubDescuentoModal(true);
  };

  const handleCerrarSubDescuentoModal = () => {
    setShowSubDescuentoModal(false);
    setIndiceDetalleParaDescuento(null);
    setSubDescuentoSeleccionado({});
  };

  const handleAgregarSubDescuentoClick = () => {
    if (indiceDetalleParaDescuento === null || !subDescuentoSeleccionado.TipoSubDescuento) return;
    const nuevosDetalles = [...detalles];
    nuevosDetalles[indiceDetalleParaDescuento] = recalcularRetencionesLinea({
      ...nuevosDetalles[indiceDetalleParaDescuento],
      SubDescuentos: [subDescuentoSeleccionado],
    }, nuevosDetalles, transaccion);
    setDetalles(nuevosDetalles);
    handleCerrarSubDescuentoModal();
  };

  const handleEliminarSubDescuento = () => {
    if (indiceDetalleParaDescuento === null) return;
    const tipoSubDescuento = detalles[indiceDetalleParaDescuento]?.SubDescuentos?.[0]?.TipoSubDescuento;
    const nuevosDetalles = [...detalles];
    nuevosDetalles[indiceDetalleParaDescuento] = recalcularRetencionesLinea({
      ...nuevosDetalles[indiceDetalleParaDescuento],
      SubDescuentos: [],
    }, nuevosDetalles, transaccion);
    setDetalles(nuevosDetalles);
    setSubDescuentoSeleccionado({ TipoSubDescuento: tipoSubDescuento });
  };

  const handleAgregarDescuentoClick = () => {
    if (descuentoGlobalSeleccionado.TipoDescuentoGlobal) {
      if (algunItemTieneRetencion(detalles)) {
        Warning({ message: MENSAJE_RETENCION_INCOMPATIBLE });
        return;
      }
      if (!todosMismoIndicador(detalles)) {
        Warning({ message: MENSAJE_ITBIS_MIXTO });
        return;
      }
      const nuevaTransaccion = {
        ...transaccion,
        TipoDescuentoGlobal: descuentoGlobalSeleccionado.TipoDescuentoGlobal,
        DescuentoGlobal: descuentoGlobalSeleccionado.DescuentoGlobal,
      };
      setTransaccion(nuevaTransaccion);
      setDetalles(recalcularTodasLasRetenciones(detalles, nuevaTransaccion));
    }
    setDescuentoGlobalSeleccionado({});
  };

  const handleAgregarItemClick = () => {
    if (itemSeleccionado && itemSeleccionado.value) {
      const cantidadAgregada = itemSeleccionado.Cantidad > 0 ? itemSeleccionado.Cantidad : 1;
      const precio = itemSeleccionado.PrecioUnitario > 0 ? itemSeleccionado.PrecioUnitario : 0.00;
      const nuevoDetalle = {
        ...itemSeleccionado,
        IdSec: itemSeleccionado.value,
        Cantidad: cantidadAgregada,
        CantidadItem: cantidadAgregada,
        PrecioUnitarioReferencia: precio,
        MontoITBISRetenido: itemSeleccionado.MontoITBISRetenido ?? 0,
        MontoISRRetenido: itemSeleccionado.MontoISRRetenido ?? 0,
        SubDescuentos: [],
      };

      const nuevaLista = [...detalles, nuevoDetalle];
      if (transaccion.TipoDescuentoGlobal && !todosMismoIndicador(nuevaLista)) {
        Warning({ message: MENSAJE_ITBIS_MIXTO });
        return;
      }
      setDetalles(recalcularTodasLasRetenciones(nuevaLista, transaccion));
    }
    setItemSeleccionado({});
    setItemLookupKey(uuid());
  };

  const subDescuentoModal = (
    <ModalContainer
      showModal={showSubDescuentoModal}
      cerrar={handleCerrarSubDescuentoModal}
      grabar={() => { }}
      title={`Descuento de Item: ${indiceDetalleParaDescuento !== null ? detalles[indiceDetalleParaDescuento]?.Nombre : ""}`}
      size="lg"
      btnGrabar={{ show: false }}
      btnCerrar={{ show: true, label: "Cerrar" }}
    >
      {indiceDetalleParaDescuento !== null && (() => {
        const descuentoAplicado = detalles[indiceDetalleParaDescuento]?.SubDescuentos?.[0];

        if (descuentoAplicado) {
          return (
            <SectionRow triple={true}>
              <InputContainer stacked label="Tipo de Descuento">
                <RadioGroup
                  options={eCF.TIPOS_DESCUENTOS}
                  selectedOption={descuentoAplicado.TipoSubDescuento}
                  disabled={true}
                />
              </InputContainer>

              <InputContainer stacked label={descuentoAplicado.TipoSubDescuento === TIPO_DESCUENTO_RECARGO_MONTO ? "Monto ($)" : "Porcentaje (%)"}>
                <CurrencyInput
                  readOnly
                  value={descuentoAplicado.TipoSubDescuento === TIPO_DESCUENTO_RECARGO_MONTO
                    ? descuentoAplicado.MontoSubDescuento
                    : descuentoAplicado.SubDescuentoPorcentaje
                  }
                />
              </InputContainer>

              {!isReadonly && (
                <InputContainer stacked label=" ">
                  <IconButton onClick={handleEliminarSubDescuento}>
                    <ToolTip message="Eliminar descuento">
                      <div>
                        <SvgComponent iconName="trash" height="25" width="25" />
                      </div>
                    </ToolTip>
                  </IconButton>
                </InputContainer>
              )}
            </SectionRow>
          );
        }

        const montoOk = subDescuentoSeleccionado.TipoSubDescuento === TIPO_DESCUENTO_RECARGO_MONTO
          && subDescuentoSeleccionado.MontoSubDescuento && (subDescuentoSeleccionado.MontoSubDescuento > 0);
        const porcentajeOk = subDescuentoSeleccionado.TipoSubDescuento === TIPO_DESCUENTO_RECARGO_PORCENTAJE
          && subDescuentoSeleccionado.SubDescuentoPorcentaje && (subDescuentoSeleccionado.SubDescuentoPorcentaje > 0);
        const puedeAgregar = montoOk || porcentajeOk;

        return (
          <SectionRow triple={true}>
            <InputContainer stacked label="Tipo de Descuento">
              <RadioGroup
                options={eCF.TIPOS_DESCUENTOS}
                selectedOption={subDescuentoSeleccionado.TipoSubDescuento}
                onChange={(e) => setSubDescuentoSeleccionado({
                  TipoSubDescuento: e.target.value,
                  MontoSubDescuento: null,
                  SubDescuentoPorcentaje: null,
                })}
              />
            </InputContainer>

            {subDescuentoSeleccionado.TipoSubDescuento && (
              <InputContainer stacked label={subDescuentoSeleccionado.TipoSubDescuento === TIPO_DESCUENTO_RECARGO_MONTO ? "Monto ($)" : "Porcentaje (%)"}>
                {subDescuentoSeleccionado.TipoSubDescuento === TIPO_DESCUENTO_RECARGO_MONTO && (
                  <CurrencyInput
                    name="MontoSubDescuento"
                    value={subDescuentoSeleccionado.MontoSubDescuento ?? ""}
                    onChange={(numericValue) => setSubDescuentoSeleccionado({
                      ...subDescuentoSeleccionado,
                      MontoSubDescuento: numericValue
                    })}
                  />
                )}

                {subDescuentoSeleccionado.TipoSubDescuento === TIPO_DESCUENTO_RECARGO_PORCENTAJE && (
                  <CurrencyInput
                    name="SubDescuentoPorcentaje"
                    value={subDescuentoSeleccionado.SubDescuentoPorcentaje ?? ""}
                    onChange={(numericValue) => setSubDescuentoSeleccionado({
                      ...subDescuentoSeleccionado,
                      SubDescuentoPorcentaje: numericValue
                    })}
                  />
                )}
              </InputContainer>
            )}

            {puedeAgregar && (
              <InputContainer stacked label=" ">
                <AnimatedIconButton
                  size="38px"
                  height="20px"
                  width="20px"
                  iconName="create"
                  message="Agregar"
                  onClick={handleAgregarSubDescuentoClick}
                />
              </InputContainer>
            )}
          </SectionRow>
        );
      })()}
    </ModalContainer>
  )

  const cambiarTipoECFConfirmModal = (
    <ModalContainer
      showModal={showCambiarTipoECFConfirmModal}
      cerrar={() => {
        setPendingTipoeCF(null);
        setShowCambiarTipoECFConfirmModal(false);
      }}
      grabar={() => {
        setTransaccion({ ...transaccion, TipoeCF: pendingTipoeCF });
        setPendingTipoeCF(null);
        setShowCambiarTipoECFConfirmModal(false);
      }}
      title={"Confirmación"}
      size="lg"
      btnGrabar={{ show: true, label: "Sí" }}
      btnCerrar={{ show: true, label: "No" }}
    >
      <p>
        El tercero seleccionado tiene un comprobante de tipo{" "}
        <strong>{eCF.TIPOS_COMPROBANTES.find((t) => t.value === pendingTipoeCF)?.label ?? pendingTipoeCF}</strong>
        , pero el tipo de comprobante a emitir es{" "}
        <strong>{eCF.TIPOS_COMPROBANTES.find((t) => t.value === transaccion.TipoeCF)?.label ?? transaccion.TipoeCF}</strong>
        .<br /><br />
        ¿Desea cambiar el tipo de comprobante del E-CF a emitir por{" "}
        <strong>{eCF.TIPOS_COMPROBANTES.find((t) => t.value === pendingTipoeCF)?.label ?? pendingTipoeCF}</strong>?
      </p>
    </ModalContainer>
  );

  return (
    <>
      <Form action="" className="form-horizontal" method="">
        <Card>
          <EditHeader
            titulo={tituloHeader}
            {...(!isReadonly && { grabar: () => grabar() })}
            {...(isReadonly && {
              clean: () => handleCleanClick(),
              imprimirRepresentacion: () => representacionImpresa(Id),
              descargarArchivoXML: () => descargarArchivoXML(),
              descargarArchivoRespuestaXML: () => descargarArchivoRespuestaXML(),
              enviarEmail: () => handleEmailClick(),
              ...(tienePermiso(Permisos.Transacciones.CANCELAR) && { cancelarECF: () => handleCancelarClick() }),
              ...(tienePermiso(Permisos.Transacciones.VISUALIZAR_LINK_QR) && { abrirLinkQR: () => abrirLinkQR() }),
            })}
            volver={true}
            volverFunc={handleVolverClick}
          />

          {showCondicionPagoEditCanvas && (
            <CondicionPagoEditCanvas
              showCanvas={showCondicionPagoEditCanvas}
              setShowCanvas={setShowCondicionPagoEditCanvas}
              showLoading={showLoading}
              hideLoading={hideLoading}
              updateList={cargarCondicionesDePago}
              onCreated={(res) => {
                const selected = { value: res.IdSec, label: res.Descripcion, Dias: res.Dias };
                setCondicionPagoSeleccionada(selected);
                if (transaccion.FechaEmision) {
                  const fechaBase = new Date(transaccion.FechaEmision);
                  fechaBase.setDate(fechaBase.getDate() + res.Dias);
                  setFechaLimitePagoFilterkey(uuid());
                  setTransaccion({ ...transaccion, FechaLimitePago: DateHelper.formatDate(fechaBase) });
                }
              }}
            />
          )}

          <ReporteViewer
            showCanvas={showCanvasReporte}
            setShowCanvas={setShowCanvasReporte}
            reporte={reporte}
          >
          </ReporteViewer>

          <EditContainer disabled={isReadonly}>
            <EditSection title="Información General" style={{}}>
              <SectionRow multilinea>
                <InputContainer stacked label="Tipo de Comprobante" labelClassName={"d-flex"}>
                  <RadioGroup
                    options={eCF.TIPOS_COMPROBANTES}
                    selectedOption={transaccion.TipoeCF}
                    disabled={isReadonly}
                    onChange={(e) => {
                      setTransaccion({
                        ...transaccion,
                        TipoeCF: e.target.value,
                      });
                    }}
                  />
                </InputContainer>
              </SectionRow>

              {transaccion.TipoeCF != TIPO_COMPROBANTE_COMPRAS && transaccion.TipoeCF != TIPO_COMPROBANTE_GASTO_MENOR && transaccion.TipoeCF != TIPO_COMPROBANTE_PAGOS_EXTERIOR && (
                <SectionRow multilinea>
                  <InputContainer stacked label="Tipo de Ingresos" labelClassName={"d-flex"}>
                    <RadioGroup
                      options={eCF.TIPOS_INGRESOS}
                      selectedOption={transaccion.TipoIngresos}
                      disabled={isReadonly}
                      onChange={(e) => {
                        setTransaccion({
                          ...transaccion,
                          TipoIngresos: e.target.value,
                        });
                      }}
                    />
                  </InputContainer>
                </SectionRow>
              )}

              {(!usuario?.Compania?.UsaSerieFiscal || isReadonly) && (
                <SectionRow columns={4}>
                  <InputContainer stacked label="e-NCF">
                    <Form.Control
                      type="text"
                      name="eNCF"
                      value={transaccion.eNCF}
                      onChange={(e) => FormHelper.handleChange(e, setTransaccion)}
                      {...(!isReadonly &&
                        { style: StyleHelper.InputRequired })
                      }
                    />
                  </InputContainer>

                  {transaccion.TipoeCF !== TIPO_COMPROBANTE_FACTURA_CONSUMO && transaccion.TipoeCF !== TIPO_COMPROBANTE_NOTA_CREDITO && (
                    <InputContainer stacked label="Fecha de Vencimiento de la Secuencia">
                      <DateTimePicker
                        key={fechaVencimientoSecuenciaFilterkey}
                        usarLabel={false}
                        esRangoFechas={false}
                        isDisabled={isReadonly}
                        required={!isReadonly}
                        soloFecha
                        fechaInicioOriginal={transaccion.FechaVencimientoSecuencia || ""}
                        onChange={(e) => {
                          setTransaccion({
                            ...transaccion,
                            FechaVencimientoSecuencia: DateHelper.formatDate(e.fechaInicio),
                          });
                        }}
                      />
                    </InputContainer>
                  )}
                </SectionRow>
              )}

              <SectionRow columns={4}>
                <InputContainer stacked label="Fecha de Emisión">
                  <DateTimePicker
                    key={fechaEmisionFilterkey}
                    usarLabel={false}
                    esRangoFechas={false}
                    isDisabled={isReadonly}
                    soloFecha
                    fechaInicioOriginal={transaccion.FechaEmision}
                    required={!isReadonly}
                    onChange={(e) => {
                      setTransaccion({
                        ...transaccion,
                        FechaEmision: DateHelper.formatDate(e.fechaInicio),
                      });
                    }}
                  />
                </InputContainer>

                {transaccion.TipoeCF != TIPO_COMPROBANTE_GASTO_MENOR && transaccion.TipoeCF != TIPO_COMPROBANTE_PAGOS_EXTERIOR && (
                  <InputContainer stacked label="Tipo de Pago">
                    <RadioGroup
                      options={eCF.TIPOS_PAGOS}
                      selectedOption={transaccion.TipoPago}
                      disabled={isReadonly || !!ncfModificadoSeleccionado.value}
                      onChange={(e) => {
                        setTransaccion({
                          ...transaccion,
                          TipoPago: e.target.value,
                          FechaLimitePago: null
                        });
                        setCondicionPagoSeleccionada(null);
                      }}
                    />
                  </InputContainer>
                )}

                {transaccion.TipoeCF != TIPO_COMPROBANTE_GASTO_MENOR && transaccion.TipoeCF != TIPO_COMPROBANTE_PAGOS_EXTERIOR && transaccion.TipoPago === TIPO_PAGO_CREDITO && (
                  <InputContainer
                    stacked
                    label={(condicionesDePago.length > 0) && !isReadonly ? "Condición de Pago" : "Fecha Límite de Pago"}
                    onLabelClick={!isReadonly ? () => setShowCondicionPagoEditCanvas(true) : undefined}
                  >
                    {(condicionesDePago.length > 0) && !isReadonly ? (
                      <Select
                        className={!isReadonly ? "react-select primary required" : "react-select primary"}
                        classNamePrefix="react-select"
                        isDisabled={isReadonly}
                        placeholder="Seleccionar condición de pago..."
                        options={condicionesDePago.map((c) => ({
                          value: c.IdSec,
                          label: `${c.Descripcion}`,
                          Dias: c.Dias,
                        }))}
                        value={condicionPagoSeleccionada}
                        onChange={(selected) => {
                          setCondicionPagoSeleccionada(selected);
                          if (selected && transaccion.FechaEmision) {
                            const fechaBase = new Date(transaccion.FechaEmision);
                            fechaBase.setDate(fechaBase.getDate() + selected.Dias);
                            setFechaLimitePagoFilterkey(uuid());
                            setTransaccion({
                              ...transaccion,
                              FechaLimitePago: DateHelper.formatDate(fechaBase),
                            });
                          } else {
                            setTransaccion({ ...transaccion, FechaLimitePago: null });
                          }
                        }}
                      />
                    ) : (
                      <DateTimePicker
                        key={fechaLimitePagoFilterkey}
                        usarLabel={false}
                        esRangoFechas={false}
                        isDisabled={isReadonly}
                        soloFecha={true}
                        fechaInicioOriginal={transaccion.FechaLimitePago}
                        required={!isReadonly}
                        onChange={(e) => {
                          setTransaccion({
                            ...transaccion,
                            FechaLimitePago: DateHelper.formatDate(e.fechaInicio),
                          });
                        }}
                      />
                    )}
                  </InputContainer>
                )}
              </SectionRow>

              <SectionRow columns={4}>
                <InputContainer stacked label="Moneda">
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    isDisabled={isReadonly}
                    name="TipoMoneda"
                    options={eCF.MONEDAS}
                    value={eCF.MONEDAS.filter(
                      (option) => option.value === (transaccion.TipoMoneda ?? eCF.MONEDAS[0].value)
                    )}
                    onChange={(e) => {
                      setTransaccion({
                        ...transaccion,
                        TipoMoneda: e.value
                      });
                    }}
                  />
                </InputContainer>

                {(transaccion.TipoMoneda ?? MONEDA_PESO_DOMINICANO_ISO) !== MONEDA_PESO_DOMINICANO_ISO && (
                  <InputContainer stacked label="Tasa de Cambio" >
                    <CurrencyInput
                      name="TipoCambio"
                      placeholder="Tasa de Cambio"
                      value={transaccion.TipoCambio}
                      style={!isReadonly ? StyleHelper.InputRequired : ""}
                      onChange={(numericValue) => {
                        setTransaccion({
                          ...transaccion,
                          TipoCambio: numericValue,
                        });
                      }}
                    />
                  </InputContainer>
                )}

                <InputContainer stacked label="Número de Factura Interna">
                  <Form.Control
                    type="text"
                    name="NumeroFacturaInterna"
                    value={transaccion.NumeroFacturaInterna ?? ""}
                    onChange={(e) => {
                      setTransaccion({
                        ...transaccion,
                        NumeroFacturaInterna: e.target.value
                      });
                    }}
                  />
                </InputContainer>
              </SectionRow>
            </EditSection>

            {transaccion.TipoeCF != TIPO_COMPROBANTE_GASTO_MENOR && !ocultarTerceroSection && (
              <EditSection title={sectionTitleTercero} style={{}}>
                <>
                  <SectionRow columns={4}>
                    {!isReadonly && (
                      <InputContainer stacked label={tipoTerceroLabel} onLabelClick={() => terceroLookupRef.current?.openTerceroEdit()}>
                        <TerceroLookup
                          key={terceroLookupKey}
                          ref={terceroLookupRef}
                          isMultiselect={false}
                          initialValue={terceroSeleccionado}
                          whereFijo={terceroWhereFijo}
                          onChange={(tercero) => {
                            if (tercero && tercero.value) {
                              setTerceroSeleccionado(tercero);

                              const transaccionActualizada = {
                                ...transaccion
                              };

                              transaccionActualizada["TipoDocumentoComprador"] = tercero.TipoDocumento;
                              transaccionActualizada["DocumentoComprador"] = tercero.Documento;
                              transaccionActualizada["RazonSocialComprador"] = tercero.RazonSocial;

                              const tipoField = CXP_TIPOS.includes(transaccion.TipoeCF)
                                ? tercero.TipoComprobanteCompra
                                : tercero.TipoComprobanteVenta;
                              var tipoECFTercero = Tercero.getTipoComprobanteECF(tipoField);
                              if (tipoECFTercero) {
                                if (transaccion.TipoeCF != undefined && transaccion.TipoeCF != "" && tipoECFTercero !== transaccion.TipoeCF) {
                                  setPendingTipoeCF(tipoECFTercero);
                                  setShowCambiarTipoECFConfirmModal(true);
                                } else if (!transaccion.TipoeCF || transaccion.TipoeCF === "") {
                                  transaccionActualizada["TipoeCF"] = tipoECFTercero;
                                }
                              }

                              setTransaccion(transaccionActualizada);
                            }
                            else {
                              setTerceroSeleccionado({});
                              setRncLookupKey(uuid());
                              setTransaccion({
                                ...transaccion,
                                TipoDocumentoComprador: "",
                                DocumentoComprador: "",
                                RazonSocialComprador: ""
                              });
                            }
                          }}
                        />
                      </InputContainer>
                    )}
                  </SectionRow>

                  <SectionRow columns={4}>
                    <InputContainer stacked
                      label={documentoTerceroLabel}
                    >
                      {isReadonly ? (
                        <Form.Control
                          readOnly
                          value={transaccion.DocumentoComprador}
                        />
                      ) : (
                        <RncLookup
                          key={rncLookupKey}
                          disabled={isReadonly}
                          required={!isReadonly && (transaccion.TipoeCF === TIPO_COMPROBANTE_FACTURA_CREDITO_FISCAL ||
                            transaccion.TipoeCF === TIPO_COMPROBANTE_COMPRAS ||
                            transaccion.TipoeCF === TIPO_COMPROBANTE_GUBERNAMENTAL ||
                            facturaConsumoSobreLimite)
                          }
                          initialValue={{
                            value: transaccion.DocumentoComprador ?? "",
                            label: transaccion.DocumentoComprador ?? "",
                            Rnc: transaccion.DocumentoComprador ?? "",
                            RazonSocial: transaccion.RazonSocialComprador ?? "",
                          }}
                          onChange={(e) => {
                            setTransaccion({
                              ...transaccion,
                              DocumentoComprador: e.Rnc,
                              RazonSocialComprador: e.RazonSocial,
                              TipoDocumentoComprador: getTipoDocumentoPorLongitud(e.Rnc),
                            });
                          }}
                        />
                      )}
                    </InputContainer>

                    <InputContainer stacked label="Tipo Documento">
                      <RadioGroup
                        options={Tercero.TIPO_DOCUMENTO_LIST}
                        selectedOption={transaccion.TipoDocumentoComprador || getTipoDocumentoPorLongitud(transaccion.DocumentoComprador)}
                        disabled={isReadonly}
                        onChange={(e) => {
                          setTransaccion({
                            ...transaccion,
                            TipoDocumentoComprador: e.target.value,
                          });
                        }}
                      />
                    </InputContainer>

                    <InputContainer stacked
                      label={razonSocialTerceroLabel}
                    >
                      <Form.Control
                        type="text"
                        name="RazonSocialComprador"
                        value={transaccion.RazonSocialComprador ?? ""}
                        onChange={(e) => FormHelper.handleChange(e, setTransaccion)}
                        {...(
                          (!isReadonly && (transaccion.TipoeCF === TIPO_COMPROBANTE_FACTURA_CREDITO_FISCAL ||
                            transaccion.TipoeCF === TIPO_COMPROBANTE_COMPRAS ||
                            transaccion.TipoeCF === TIPO_COMPROBANTE_REGIMEN_ESPECIAL ||
                            transaccion.TipoeCF === TIPO_COMPROBANTE_GUBERNAMENTAL ||
                            transaccion.TipoeCF === TIPO_COMPROBANTE_EXPORTACIONES ||
                            facturaConsumoSobreLimite)) &&
                          { style: StyleHelper.InputRequired })
                        }
                      />
                    </InputContainer>
                  </SectionRow>
                </>
              </EditSection>
            )}

            {!isReadonly &&
              <SectionRow>
                <div className="d-flex">
                  <Form.Check
                    className="divContainer ml-2 mt-2"
                    type="checkbox"
                    aria-label="Indicar Información de Referencia"
                    onChange={() => {
                      const nextValue = !showInfoReferencia;
                      setShowInfoReferencia(nextValue);

                      if (!isReadonly && !nextValue) {
                        setNcfModificadoSeleccionado({});
                        setFechaNcfModificadoFilterkey(uuid());
                        setTransaccion({
                          ...transaccion,
                          NCFModificado: "",
                          FechaNCFModificado: null,
                          CodigoModificacion: null
                        });
                      }
                    }}
                    id="chkShowInfoRef"
                    name="showInfoRef"
                    checked={showInfoReferencia || esNotaCredito || esNotaDebito}
                    disabled={esNotaCredito || esNotaDebito}
                  />
                  <label
                    htmlFor="chkShowInfoRef"
                    style={{ width: "450px" }}
                    className="mt-2"
                  >
                    Indicar Información de Referencia
                  </label>
                </div>
              </SectionRow>
            }

            {(isReadonly ? tieneInformacionReferencia : (esNotaDebito || esNotaCredito || showInfoReferencia)) && (
              <EditSection title="Información de Referencia" style={{}}>
                <SectionRow columns={4}>
                  <InputContainer stacked label="NCF Modificado">
                    {isReadonly ? (
                      <Form.Control
                        readOnly
                        value={transaccion.NCFModificado}
                      />
                    ) : (
                      <TransaccionesLookup
                        disabled={isReadonly}
                        isMultiselect={false}
                        initialValue={ncfModificadoSeleccionado}
                        required={esNotaDebito || esNotaCredito}
                        onChange={(selected) => {
                          if (selected && selected.value) {
                            setNcfModificadoSeleccionado(selected);

                            let fecha = null;
                            if (selected.Fecha) {
                              const [day, month, year] = selected.Fecha.trim().split('/').map(Number);
                              fecha = new Date(year, month - 1, day);
                            }

                            setTransaccion({
                              ...transaccion,
                              NCFModificado: selected.ENCF,
                              FechaNCFModificado: fecha,
                              TipoPago: selected.TipoPago ?? transaccion.TipoPago,
                            });
                          } else {
                            setNcfModificadoSeleccionado({});
                            setFechaNcfModificadoFilterkey(uuid());
                            setTransaccion({
                              ...transaccion,
                              NCFModificado: "",
                              FechaNCFModificado: null
                            });
                          }
                        }}
                      />
                    )}
                  </InputContainer>

                  <InputContainer stacked label="Fecha NCF Modificado">
                    <DateTimePicker
                      key={fechaNcfModificadoFilterkey}
                      usarLabel={false}
                      esRangoFechas={false}
                      isDisabled={isReadonly}
                      soloFecha={true}
                      fechaInicioOriginal={transaccion.FechaNCFModificado}
                      required={!isReadonly && (esNotaDebito || esNotaCredito)}
                      onChange={(e) => {
                        setTransaccion({
                          ...transaccion,
                          FechaNCFModificado: DateHelper.formatDate(e.fechaInicio),
                        });
                      }}
                    />
                  </InputContainer>

                  <InputContainer stacked label="Código de Modificación">
                    <Select
                      className={!isReadonly && (esNotaDebito || esNotaCredito) ? "react-select primary required" : "react-select primary"}
                      classNamePrefix="react-select"
                      isDisabled={isReadonly}
                      name="CodigoModificacion"
                      options={eCF.CODIGOS_MODIFICACION}
                      value={eCF.CODIGOS_MODIFICACION.filter(
                        (option) => option.value === transaccion.CodigoModificacion
                      )}
                      onChange={(e) => {
                        setTransaccion({
                          ...transaccion,
                          CodigoModificacion: e.value
                        });
                      }}
                    />
                  </InputContainer>
                </SectionRow>
              </EditSection>
            )}

            {transaccion.TipoeCF !== TIPO_COMPROBANTE_GASTO_MENOR && transaccion.TipoeCF !== TIPO_COMPROBANTE_PAGOS_EXTERIOR && (
              <EditSection title="Información de Descuento" style={{}}>
                {transaccion.TipoDescuentoGlobal ? (
                  <SectionRow columns={4}>
                    <InputContainer stacked label="Tipo descuento">
                      <RadioGroup
                        options={eCF.TIPOS_DESCUENTOS}
                        disabled={true}
                        selectedOption={transaccion.TipoDescuentoGlobal}
                      />
                    </InputContainer>

                    <InputContainer stacked label="Descuento">
                      <CurrencyInput
                        readOnly
                        value={transaccion.DescuentoGlobal ?? 0}
                        onChange={() => { }}
                      />
                    </InputContainer>

                    {!isReadonly && (
                      <InputContainer>
                        <IconButton
                          onClick={() => {
                            const nuevaTransaccion = {
                              ...transaccion,
                              TipoDescuentoGlobal: null,
                              DescuentoGlobal: null,
                            };
                            setTransaccion(nuevaTransaccion);
                            setDetalles(recalcularTodasLasRetenciones(detalles, nuevaTransaccion));
                            setDescuentoGlobalSeleccionado({});
                          }}
                        >
                          <ToolTip message="Eliminar descuento">
                            <div>
                              <SvgComponent iconName="trash" height="25" width="25" />
                            </div>
                          </ToolTip>
                        </IconButton>
                      </InputContainer>
                    )}
                  </SectionRow>
                ) : (
                  <SectionRow columns={4}>
                    <InputContainer stacked label="Tipo descuento">
                      <RadioGroup
                        options={eCF.TIPOS_DESCUENTOS}
                        selectedOption={descuentoGlobalSeleccionado.TipoDescuentoGlobal}
                        onChange={(e) => {
                          setDescuentoGlobalSeleccionado({
                            ...descuentoGlobalSeleccionado,
                            TipoDescuentoGlobal: e.target.value,
                          });
                        }}
                      />
                    </InputContainer>

                    <InputContainer stacked label="Descuento">
                      <CurrencyInput
                        name="DescuentoGlobal"
                        value={descuentoGlobalSeleccionado.DescuentoGlobal ?? 0}
                        onChange={(numericValue) => {
                          setDescuentoGlobalSeleccionado({
                            ...descuentoGlobalSeleccionado,
                            DescuentoGlobal: numericValue,
                          });
                        }}
                      />
                    </InputContainer>

                    {descuentoGlobalSeleccionado.TipoDescuentoGlobal && descuentoGlobalSeleccionado.DescuentoGlobal > 0 && (
                      <InputContainer>
                        <AnimatedIconButton
                          size="38px"
                          height="20px"
                          width="20px"
                          iconName="create"
                          message="Agregar"
                          onClick={handleAgregarDescuentoClick}
                        />
                      </InputContainer>
                    )}
                  </SectionRow>
                )}
              </EditSection>
            )}

            <EditSection title="Detalles de la Transación">
              <Row className="align-items-end">
                {!isReadonly && (
                  <Col md={2}>
                    <InputContainer stacked label="Item" onLabelClick={() => itemLookupRef.current?.openItemEdit()}>
                      <ItemLookup
                        ref={itemLookupRef}
                        key={itemLookupKey}
                        isMultiselect={false}
                        initialValue={itemSeleccionado}
                        whereFijo={itemWhereFijo}
                        onChange={(item) => {
                          setItemSeleccionado(item);
                        }}
                      />
                    </InputContainer>
                  </Col>
                )}

                {itemSeleccionado && itemSeleccionado.value && (
                  <Col md={1}>
                    <InputContainer stacked label="Cantidad">
                      <Form.Control
                        type="number"
                        name="Cantidad"
                        placeholder="Cantidad"
                        value={itemSeleccionado.Cantidad ?? 1}
                        onChange={(e) => {
                          setItemSeleccionado(recalcularRetencionesItemSeleccionado({
                            ...itemSeleccionado,
                            Cantidad: e.target.value,
                          }));
                        }}
                      />
                    </InputContainer>
                  </Col>
                )}

                {itemSeleccionado && itemSeleccionado.value && (
                  <Col md={1.5}>
                    <InputContainer stacked label="Precio unitario">
                      <CurrencyInput
                        name="PrecioUnitario"
                        placeholder="Precio Unitario"
                        value={itemSeleccionado.PrecioUnitario || 0}
                        readOnly={!puedeEditarPrecio}
                        onChange={(numericValue) => {
                          setItemSeleccionado(recalcularRetencionesItemSeleccionado({
                            ...itemSeleccionado,
                            PrecioUnitario: numericValue,
                          }));
                        }}
                      />
                    </InputContainer>
                  </Col>
                )}

                {itemSeleccionado && itemSeleccionado.value && (
                  <Col md={2}>
                    <InputContainer stacked label="Tasa ITBIS">
                      {puedeEditarITBIS && (
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          options={eCF.INDICADORES_FACTURACION}
                          value={eCF.INDICADORES_FACTURACION.find(opt => opt.value === itemSeleccionado.IndicadorFacturacion) ?? null}
                          onChange={(sel) => {
                            const nuevoValor = sel ? sel.value : null;
                            if (transaccion.TipoDescuentoGlobal && nuevoValor !== INDICADOR_FACTURACION_NO_FACTURABLE) {
                              const otros = detalles.filter(d => d.IndicadorFacturacion !== INDICADOR_FACTURACION_NO_FACTURABLE);
                              if (otros.length > 0 && otros[0].IndicadorFacturacion !== nuevoValor) {
                                Warning({ message: MENSAJE_ITBIS_MIXTO });
                                return;
                              }
                            }
                            setItemSeleccionado({
                              ...itemSeleccionado,
                              IndicadorFacturacion: nuevoValor,
                            });
                          }}
                          menuPortalTarget={document.body}
                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        />
                      )}
                      <CurrencyInput value={itbisCalculado} readOnly />
                    </InputContainer>
                  </Col>
                )}

                {itemSeleccionado && itemSeleccionado.value && (
                  <Col md={2}>
                    <InputContainer stacked label="Retención ITBIS">
                      {puedeEditarRetITBIS && (
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          isClearable
                          options={itbisOptionsForTipo}
                          value={itbisOptionsForTipo.find(opt => opt.value === itemSeleccionado.TipoRetencionITBIS) ?? null}
                          onChange={(sel) => {
                            if (sel && transaccion.TipoDescuentoGlobal) {
                              Warning({ message: MENSAJE_RETENCION_INCOMPATIBLE });
                              return;
                            }
                            setItemSeleccionado(recalcularRetencionesItemSeleccionado({
                              ...itemSeleccionado,
                              TipoRetencionITBIS: sel ? sel.value : null,
                            }));
                          }}
                          menuPortalTarget={document.body}
                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        />
                      )}
                      <CurrencyInput value={itemSeleccionado.MontoITBISRetenido || 0} readOnly />
                    </InputContainer>
                  </Col>
                )}

                {itemSeleccionado && itemSeleccionado.value && (
                  <Col md={2}>
                    <InputContainer stacked label="Retención ISR">
                      {puedeEditarRetISR && (
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          isClearable
                          options={isrOptionsForTipo}
                          value={isrOptionsForTipo.find(opt => opt.value === itemSeleccionado.TipoRetencionISR) ?? null}
                          onChange={(sel) => {
                            if (sel && transaccion.TipoDescuentoGlobal) {
                              Warning({ message: MENSAJE_RETENCION_INCOMPATIBLE });
                              return;
                            }
                            setItemSeleccionado(recalcularRetencionesItemSeleccionado({
                              ...itemSeleccionado,
                              TipoRetencionISR: sel ? sel.value : null,
                            }));
                          }}
                          menuPortalTarget={document.body}
                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        />
                      )}
                      <CurrencyInput value={itemSeleccionado.MontoISRRetenido || 0} readOnly />
                    </InputContainer>
                  </Col>
                )}

                {itemSeleccionado && itemSeleccionado.value && (
                  <Col md={1}>
                    <InputContainer>
                      <AnimatedIconButton
                        size="38px"
                        height="20px"
                        width="20px"
                        iconName="create"
                        message="Agregar"
                        onClick={handleAgregarItemClick}
                      />
                    </InputContainer>
                  </Col>
                )}
              </Row>

              <GridView
                pagination={pagination}
                setPagination={setPagination}
                dataSource={detalles}
                hideFilters={true}
                height="auto"
              >
                <GridView.Column
                  isField
                  width="120px"
                  showClearFilter={true}
                  bodyRenderer={(row) => {
                    const index = detalles.findIndex(item => item === row);
                    const count = row.SubDescuentos?.length || 0;
                    return (
                      <>
                        {!isReadonly && (
                          <div className="float-right">
                            <IconButton
                              onClick={() => {
                                const indiceEncontrado = detalles.findIndex(item => item === row);
                                handleEliminarDetalle(indiceEncontrado);
                              }}
                            >
                              <ToolTip message="Eliminar">
                                <div>
                                  <SvgComponent
                                    iconName="trash"
                                    height="25"
                                    width="25"
                                  />
                                </div>
                              </ToolTip>
                            </IconButton>
                          </div>
                        )}

                        {(!isReadonly || count > 0) && (
                          <div className="float-right">
                            <div onClick={() => handleAbrirSubDescuentoModal(index)} style={{ cursor: "pointer" }}>
                              <ToolTip message={"Descuento detallado"}>
                                <div style={{ position: "relative" }}>
                                  <SvgComponent
                                    iconName="descuento"
                                    height="25"
                                    width="25"
                                  />
                                  {count > 0 && (
                                    <span style={{
                                      position: "absolute", top: "0px", right: "-5px",
                                      background: "red", color: "white", borderRadius: "50%",
                                      fontSize: "10px", width: "16px", height: "16px",
                                      display: "flex", alignItems: "center", justifyContent: "center",
                                    }}>
                                      {count}
                                    </span>
                                  )}
                                </div>
                              </ToolTip>
                            </div>
                          </div>
                        )}

                        {!isReadonly && puedeEditarAlgunCampoFila && (
                          <div className="float-right">
                            <IconButton onClick={() => toggleFilaEnEdicion(index)}>
                              <ToolTip message={filasEnEdicion.has(index) ? "Bloquear fila" : "Editar fila"}>
                                <div>
                                  <SvgComponent
                                    iconName={filasEnEdicion.has(index) ? "cancel" : "pencil"}
                                    height="25"
                                    width="25"
                                  />
                                </div>
                              </ToolTip>
                            </IconButton>
                          </div>
                        )}
                      </>
                    );
                  }}
                />
                <GridView.Column
                  headerText="#"
                  width="50px"
                  bodyRenderer={(row) => (
                    <div style={{ textAlign: 'center' }}>
                      {detalles.findIndex(item => item === row) + 1}
                    </div>
                  )}
                />
                <GridView.Column
                  headerText="Nombre"
                  dataField="Nombre"
                />
                <GridView.Column
                  headerText="Bien o Servicio"
                  bodyRenderer={(row) => {
                    const index = detalles.findIndex(item => item === row);
                    return (
                      <div style={{ textAlign: 'left', paddingLeft: '8px', width: '150px' }}>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          isDisabled={isReadonly}
                          name="IndicadorBienOServicio"
                          options={eCF.INDICADOR_BIEN_SERVICIO}
                          value={eCF.INDICADOR_BIEN_SERVICIO.find(opt => opt.value === row.IndicadorBienOServicio)}
                          onChange={(selectedOption) => {
                            handleDetalleChange(index, {
                              target: {
                                name: "IndicadorBienOServicio",
                                value: selectedOption ? selectedOption.value : "",
                              }
                            });
                          }}
                          menuPortalTarget={document.body}
                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        />
                      </div>
                    );
                  }}
                />
                <GridView.Column
                  headerText="Cantidad"
                  bodyRenderer={(row) => {
                    const index = detalles.findIndex(item => item === row);
                    return (
                      <div style={{ textAlign: 'left', paddingLeft: '8px' }}>
                        <Form.Control
                          type="number"
                          name="Cantidad"
                          value={row.Cantidad}
                          onChange={(event) => handleDetalleChange(index, event)}
                          style={{ maxWidth: '110px' }}
                          min="1"
                        />
                      </div>
                    );
                  }}
                />
                <GridView.Column
                  headerText="Precio Unitario"
                  bodyRenderer={(row) => {
                    const index = detalles.findIndex(item => item === row);
                    const editable = filaEditable(index, puedeEditarPrecio);
                    return (
                      <CurrencyInput
                        name="PrecioUnitario"
                        value={row.PrecioUnitario || 0}
                        readOnly={!editable}
                        onChange={(numericValue) =>
                          handleDetalleChange(index, { target: { name: "PrecioUnitario", value: numericValue } })
                        }
                      />
                    );
                  }}
                />
                <GridView.Column
                  headerText="ITBIS"
                  bodyRenderer={(row) => {
                    const index = detalles.findIndex(item => item === row);
                    const editable = filaEditable(index, puedeEditarITBIS);
                    const { itbisLinea: itbis } = calcularLineaConDescuento(
                      row, detalles, transaccion, itbisOptionsForTipo, isrOptionsForTipo
                    );
                    if (!editable) {
                      return (
                        <div style={{ textAlign: 'left', paddingLeft: '8px' }}>
                          <CurrencyInput value={itbis} readOnly />
                        </div>
                      );
                    }
                    return (
                      <div style={{ textAlign: 'left', paddingLeft: '8px' }}>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          name="IndicadorFacturacion"
                          options={eCF.INDICADORES_FACTURACION}
                          value={eCF.INDICADORES_FACTURACION.find(opt => opt.value === row.IndicadorFacturacion)}
                          onChange={(selectedOption) => {
                            const nuevoValor = selectedOption ? selectedOption.value : "";
                            if (transaccion.TipoDescuentoGlobal && nuevoValor !== "" && nuevoValor !== INDICADOR_FACTURACION_NO_FACTURABLE) {
                              const simulada = detalles.map((d, i) => i === index ? { ...d, IndicadorFacturacion: nuevoValor } : d);
                              if (!todosMismoIndicador(simulada)) {
                                Warning({ message: MENSAJE_ITBIS_MIXTO });
                                return;
                              }
                            }
                            handleDetalleChange(index, {
                              target: {
                                name: "IndicadorFacturacion",
                                value: nuevoValor,
                              }
                            });
                          }}
                          menuPortalTarget={document.body}
                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        />
                        <CurrencyInput value={itbis} readOnly />
                      </div>
                    );
                  }}
                />
                <GridView.Column
                  headerText="Retención itbis"
                  bodyRenderer={(row) => {
                    const index = detalles.findIndex(item => item === row);
                    const editable = filaEditable(index, puedeEditarRetITBIS);
                    if (!editable) {
                      return (
                        <div style={{ minWidth: '200px' }}>
                          <CurrencyInput
                            readOnly={true}
                            name="MontoITBISRetenido"
                            value={row.MontoITBISRetenido || 0}
                          />
                        </div>
                      );
                    }
                    return (
                      <div style={{ minWidth: '200px' }}>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          isClearable
                          options={itbisOptionsForTipo}
                          value={itbisOptionsForTipo.find(opt => opt.value === row.TipoRetencionITBIS) ?? null}
                          onChange={(sel) => {
                            if (sel && transaccion.TipoDescuentoGlobal) {
                              Warning({ message: MENSAJE_RETENCION_INCOMPATIBLE });
                              return;
                            }
                            const nuevosDetalles = [...detalles];
                            const lineaActualizada = { ...nuevosDetalles[index], TipoRetencionITBIS: sel ? sel.value : null };
                            nuevosDetalles[index] = recalcularRetencionesLinea(lineaActualizada, nuevosDetalles, transaccion);
                            setDetalles(nuevosDetalles);
                          }}
                          menuPortalTarget={document.body}
                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        />
                        <CurrencyInput
                          readOnly={true}
                          name="MontoITBISRetenido"
                          value={row.MontoITBISRetenido || 0}
                          onChange={(numericValue) =>
                            handleDetalleChange(index, { target: { name: "MontoITBISRetenido", value: numericValue } })
                          }
                        />
                      </div>
                    );
                  }}
                />
                <GridView.Column
                  headerText="Retención Isr"
                  bodyRenderer={(row) => {
                    const index = detalles.findIndex(item => item === row);
                    const editable = filaEditable(index, puedeEditarRetISR);
                    if (!editable) {
                      return (
                        <div style={{ minWidth: '200px' }}>
                          <CurrencyInput
                            readOnly={true}
                            name="MontoISRRetenido"
                            value={row.MontoISRRetenido || 0}
                          />
                        </div>
                      );
                    }
                    return (
                      <div style={{ minWidth: '200px' }}>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          isClearable
                          options={isrOptionsForTipo}
                          value={isrOptionsForTipo.find(opt => opt.value === row.TipoRetencionISR) ?? null}
                          onChange={(sel) => {
                            if (sel && transaccion.TipoDescuentoGlobal) {
                              Warning({ message: MENSAJE_RETENCION_INCOMPATIBLE });
                              return;
                            }
                            const nuevosDetalles = [...detalles];
                            const lineaActualizada = { ...nuevosDetalles[index], TipoRetencionISR: sel ? sel.value : null };
                            nuevosDetalles[index] = recalcularRetencionesLinea(lineaActualizada, nuevosDetalles, transaccion);
                            setDetalles(nuevosDetalles);
                          }}
                          menuPortalTarget={document.body}
                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        />
                        <CurrencyInput
                          readOnly={true}
                          name="MontoISRRetenido"
                          value={row.MontoISRRetenido || 0}
                          onChange={(numericValue) =>
                            handleDetalleChange(index, { target: { name: "MontoISRRetenido", value: numericValue } })
                          }
                        />
                      </div>
                    );
                  }}
                />
                {transaccion.DescuentoGlobalODetallado === 2 && (
                  <GridView.Column
                    headerText="Descuento Detallado"
                    bodyRenderer={(row) => {
                      const index = detalles.findIndex(item => item === row);
                      return (
                        <div style={{ textAlign: 'left', paddingLeft: '8px' }}>
                          <Form.Control
                            type="number"
                            name="DescuentoDetallado"
                            value={row.DescuentoDetallado || 0}
                            onChange={(event) => handleDetalleChange(index, event)}
                            style={{ maxWidth: '110px' }}
                            min="0"
                            step="0.01"
                          />
                        </div>
                      );
                    }}
                  />
                )}
              </GridView>
            </EditSection>

            {mostrarDetallesCobro && (
              <EditSection title="Detalles de Cobro">
                {!isReadonly && (
                  <Row className="align-items-end">
                    <Col md={12}>
                      <InputContainer stacked label="Forma de Pago">
                        <RadioGroup
                          options={eCF.FORMAS_PAGO}
                          selectedOption={formaPagoSeleccionada}
                          onChange={(e) => setFormaPagoSeleccionada(e.target.value)}
                        />
                      </InputContainer>
                    </Col>
                  </Row>
                )}
                {!isReadonly && (
                  <Row className="align-items-end">
                    <Col md={2}>
                      <InputContainer stacked label="Monto Cobrado">
                        <CurrencyInput
                          name="MontoCobrado"
                          placeholder="Monto Cobrado"
                          value={montoCobradoSeleccionado || 0}
                          onChange={(numericValue) => setMontoCobradoSeleccionado(numericValue)}
                        />
                      </InputContainer>
                    </Col>
                    <Col md={1}>
                      <InputContainer>
                        <AnimatedIconButton
                          size="38px"
                          height="20px"
                          width="20px"
                          iconName="create"
                          message="Agregar"
                          onClick={handleAgregarFormaPagoClick}
                        />
                      </InputContainer>
                    </Col>
                  </Row>
                )}

                <GridView
                  pagination={{ EsPaginable: false }}
                  setPagination={() => { }}
                  dataSource={formasPagos}
                  hideFilters={true}
                  height="auto"
                >
                  <GridView.Column
                    isField
                    width="100px"
                    bodyRenderer={(row) => {
                      const index = formasPagos.findIndex(item => item === row);
                      return (
                        <>
                          {!isReadonly && (
                            <div className="float-right">
                              <IconButton onClick={() => handleEliminarFormaPago(index)}>
                                <ToolTip message="Eliminar">
                                  <div>
                                    <SvgComponent iconName="trash" height="25" width="25" />
                                  </div>
                                </ToolTip>
                              </IconButton>
                            </div>
                          )}
                          {!isReadonly && (
                            <div className="float-right">
                              <IconButton onClick={() => toggleFilaFormaPagoEnEdicion(index)}>
                                <ToolTip message={filasFormasPagosEnEdicion.has(index) ? "Bloquear fila" : "Editar fila"}>
                                  <div>
                                    <SvgComponent
                                      iconName={filasFormasPagosEnEdicion.has(index) ? "cancel" : "pencil"}
                                      height="25"
                                      width="25"
                                    />
                                  </div>
                                </ToolTip>
                              </IconButton>
                            </div>
                          )}
                        </>
                      );
                    }}
                  />
                  <GridView.Column
                    headerText="#"
                    width="50px"
                    bodyRenderer={(row) => (
                      <div style={{ textAlign: 'center' }}>
                        {formasPagos.findIndex(item => item === row) + 1}
                      </div>
                    )}
                  />
                  <GridView.Column
                    headerText="Forma de Pago"
                    bodyRenderer={(row) => {
                      const index = formasPagos.findIndex(item => item === row);
                      const editable = !isReadonly && filasFormasPagosEnEdicion.has(index);
                      if (!editable) {
                        const opt = eCF.FORMAS_PAGO.find(o => o.value === row.FormaPago);
                        return (
                          <div style={{ textAlign: 'left', paddingLeft: '8px' }}>
                            {opt?.label ?? row.FormaPago}
                          </div>
                        );
                      }
                      return (
                        <div style={{ textAlign: 'left', paddingLeft: '8px', minWidth: '200px' }}>
                          <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            options={eCF.FORMAS_PAGO}
                            value={eCF.FORMAS_PAGO.find(o => o.value === row.FormaPago) ?? null}
                            onChange={(sel) => handleFormaPagoChange(index, "FormaPago", sel ? sel.value : null)}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                          />
                        </div>
                      );
                    }}
                  />
                  <GridView.Column
                    headerText="Monto Cobrado"
                    bodyRenderer={(row) => {
                      const index = formasPagos.findIndex(item => item === row);
                      const editable = !isReadonly && filasFormasPagosEnEdicion.has(index);
                      return (
                        <CurrencyInput
                          name="MontoPago"
                          value={row.MontoPago || 0}
                          readOnly={!editable}
                          onChange={(numericValue) => handleFormaPagoChange(index, "MontoPago", numericValue)}
                        />
                      );
                    }}
                  />
                </GridView>
              </EditSection>
            )}

            {detalles.length > 0 && (
              <EditSection title="Totales" style={{ textAlign: 'right', marginRight: '10px' }}>
                <Row>
                  <Col md={{ span: 4, offset: 8 }} className="d-flex flex-column align-items-end">
                    <InputContainer stacked label="SubTotal">
                      <MontoField value={subtotal.toLocaleString('es-DO', { minimumFractionDigits: 2 })} />
                    </InputContainer>

                    {montosDesglosados.descuentoTotalFmt > 0 && (
                      <InputContainer stacked label="Descuento">
                        <MontoField value={montosDesglosados.descuentoTotalFmt} />
                      </InputContainer>
                    )}

                    <InputContainer stacked label="ITBIS">
                      <MontoField value={montosDesglosados.impuestoTotalFmt} />
                    </InputContainer>

                    {totalITBISRetenido > 0 && (
                      <InputContainer stacked label="Retención ITBIS">
                        <MontoField value={totalITBISRetenido.toLocaleString('es-DO', { minimumFractionDigits: 2 })} />
                      </InputContainer>
                    )}

                    {totalISRRetenido > 0 && (
                      <InputContainer stacked label="Retención ISR">
                        <MontoField value={totalISRRetenido.toLocaleString('es-DO', { minimumFractionDigits: 2 })} />
                      </InputContainer>
                    )}

                    <InputContainer stacked label="Total">
                      <MontoField value={montosDesglosados.montoTotalConImpuestosFmt} />
                    </InputContainer>

                    <InputContainer stacked label="Total a Pagar">
                      <MontoField value={totalAPagar.toLocaleString('es-DO', { minimumFractionDigits: 2 })} />
                    </InputContainer>

                    {mostrarDetallesCobro && (
                      <>
                        <InputContainer stacked label="Total Cobrado">
                          <MontoField value={totalCobrado.toLocaleString('es-DO', { minimumFractionDigits: 2 })} />
                        </InputContainer>

                        <InputContainer stacked label="Falta por cobrar">
                          <MontoField value={faltaPorCobrar.toLocaleString('es-DO', { minimumFractionDigits: 2 })} />
                        </InputContainer>

                        {totalDevuelta > 0 && (
                          <InputContainer stacked label="Total Devuelta">
                            <MontoField value={totalDevuelta.toLocaleString('es-DO', { minimumFractionDigits: 2 })} />
                          </InputContainer>
                        )}
                      </>
                    )}
                  </Col>
                </Row>
              </EditSection>
            )}
          </EditContainer>
        </Card>
      </Form>

      {showSubDescuentoModal && subDescuentoModal}

      {showCambiarTipoECFConfirmModal && cambiarTipoECFConfirmModal}

      <ModalContainer
        showModal={showEmailModal}
        size="lg"
        title="Enviar Representación Impresa Por Email"
        btnGrabar={{ label: "Enviar Email", show: true }}
        cerrar={() => setShowEmailModal(false)}
        grabar={() => enviarRepresentacionEmail()}
      >
        <EditSection>
          <InputContainer stacked label="Email">
            <Form.Control
              value={transaccion.CorreoComprador ?? ""}
              onChange={(e) =>
                setTransaccion({ ...transaccion, CorreoComprador: e.target.value })
              }
            />
          </InputContainer>
        </EditSection>
      </ModalContainer>

      <ModalContainer
        showModal={showCancelarModal}
        size="lg"
        title={`Nota de Cancelación Transacción: ${Id}`}
        subtitle={`NCF: ${transaccion.eNCF}`}
        btnGrabar={{ label: "Generar Nota de Cancelación", show: true }}
        cerrar={() => setShowCancelarModal(false)}
        grabar={() => cancelarECF()}
      >
        <EditSection>
          <InputContainer stacked label="Fecha de Emisión">
            <DateTimePicker
              soloFecha={true}
              usarLabel={false}
              fechaInicioOriginal={cancelacionData.fechaEmisionCancelacion}
              onChange={(e) => {
                if (e.fechaInicio != null)
                  setCancelacionData({
                    ...cancelacionData,
                    fechaEmisionCancelacion: DateHelper.formatDate(e.fechaInicio),
                  });
              }}
            />
          </InputContainer>
          <InputContainer stacked label="Tipo Nota de Cancelación">
            <Select
              className="react-select primary mb-2"
              classNamePrefix="react-select"
              isDisabled={true}
              options={TIPO_NOTAS_CANCELACION}
              value={TIPO_NOTAS_CANCELACION.filter(
                (o) => o.value === (cancelacionData.TipoNotaCancelacion ?? TIPO_NOTAS_CANCELACION[0]?.value)
              )}
              onChange={(e) =>
                setCancelacionData({ ...cancelacionData, TipoNotaCancelacion: e.value })
              }
            />
          </InputContainer>
        </EditSection>
      </ModalContainer>
    </>
  );
}
